import { useStubs } from '../hooks/useStubs.js';
import { centsToUsd, iso } from '../lib/format.js';
import BankingPanel from '../components/pay/BankingForm.jsx';

export default function PayPage() {
  const { data: stubs = [] } = useStubs();

  return (
    <>
      <div className="panel">
        <h3 className="panel-title">
          <span><i className="ph ph-receipt" /> My pay stubs</span>
        </h3>
        {stubs.length ? (
          <table className="tbl">
            <thead>
              <tr>
                <th>Period</th>
                <th>Pay date</th>
                <th className="num">Hrs</th>
                <th className="num">Net</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {stubs.map(s => (
                <tr key={s.id}>
                  <td>{iso(s.period_start)} → {iso(s.period_end - 1)}</td>
                  <td>{s.pay_date ? iso(s.pay_date) : '—'}</td>
                  <td className="num">{((s.regular_hrs || 0) + (s.ot_hrs || 0)).toFixed(2)}</td>
                  <td className="num">{centsToUsd(s.gross_cents)}</td>
                  <td>
                    <a className="btn-sm"
                      href={`/api/pay/runs/${s.pay_run_id}/stubs/${s.id}`}
                      target="_blank" rel="noopener">Open</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : <div className="loading">No pay stubs yet.</div>}
      </div>

      <BankingPanel />
    </>
  );
}
